import React, { Component } from 'react';
import { Link } from "react-router";
import PropTypes from 'prop-types';
import { database } from '../firebase';

class Taslak extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: '',
            userImage: '/default_user.jpg'
        };
    }

    componentDidMount() {
        const { draftAuthor } = this.props;
        database.ref(`users/${draftAuthor}`).get().then((snapshot) => {
            if (snapshot.exists()) {
                this.setState({
                    userName: snapshot.val().userName,
                    userImage: snapshot.val().userImage
                });
            }
        });
    }

    render() {
        const { draftId, draftTitle, draftContent, draftImage, draftShared } = this.props;
        const { userName, userImage } = this.state;

        return (
            <Link to={`/taslak/${draftId}`}>
                <div className="card">
                    <Link to="/profil">
                        <div style={{ display: "flex", marginBottom: "10px" }}>
                            <img src={userImage} alt="User" className="userImage" />
                            <div className="userName">{userName}</div>
                        </div>
                    </Link>
                    <img src={draftImage || "/default.jpg"} className="banner" alt="Yazının Görseli" />
                    <b className="başlık">{draftTitle || "Başlık boş."}</b>
                    <div className="content">{draftContent || "İçerik boş."}</div>
                    <div style={draftShared ? {} : { color: "#eee" }} className="date">{draftShared ? "Yayınlandı" : "Taslak"}</div>
                </div>

            <style>{`
            
            .main {
                max-width: 762px;
                width: 100%;
                margin: 0 auto;
                margin-top: 0px;
                padding: 0;
                text-align: center;
              }
      
              .card {
                border-radius: 20px;
                border-radius: 20px 7px 20px 7px;
                margin: 10px 10px;
                padding: 15px;
                background: #F57029;
                box-shadow: 0px 0px 4px rgba(0,0,0,.0);
                width: 200px;
                max-width: 200px;
                height: 300px;
                display: inline-block;
                transition: .2s;
                text-align: left;
              }

              .card:hover {
                background: #d95e1c;
              }
      
              .card .banner {
                position: relative;
                margin: auto;
                border-radius: 5px;
                width: 100%;
                height: 140px;
                object-fit: cover;
              }

              .userName {
                padding: 8px 0px 0 8px;
                display: block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              .userImage {
                width: 32px;
                height: 32px;
                background: #fff;
                border-radius: 100%;
                object-fit: cover;
              }
      
              h1 {
                margin-top: 100px;
                margin-bottom: 0;
                text-align: center;
              }
      
              h3 {
                margin-bottom: 100px;
                text-align: center;
              }
      
              .başlık {
                display: block;
                margin-top: 3px;
                color: #fff;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              .content {
                color: #eee;
                display: block;
                font-size: 13px;
                height: 64px;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .likeDiv {
                position: absolute;
                margin-top: 10px;
                font-weight: bold;
              }

              .like {
                position: absolute;
                top: 1px;
                margin-left: 12px;
                width: 20px;
                height: 17px;
              }
      
              .date {
                float: right;
                text-align: right;
                font-weight: bold;
                color: #fff;
                margin: 10px 0 0px 0;
                display: flex;
              }
      
              @media (max-width: 623px) {
                .main {
                  width: 100%;
                  max-width: 80%;
                }
      
                .card {
                  width: 100%;
                  height: auto;
                  max-width: 90%;
                  margin: 15px 0px;
                }
      
                .date {
                  margin: 10px 0 0px 0;
                }
              }
            `}</style>

         </Link>
        )
    }
}

Taslak.propTypes = {
  draftTitle: PropTypes.string,
  draftContent: PropTypes.string,
  draftImage: PropTypes.string,
  draftAuthor: PropTypes.string,
  draftShared: PropTypes.bool
}
export default Taslak;